import { Translations } from './types';

export const es: Translations = {
  // Navigation
  nav: {
    features: 'Características',
    about: 'Acerca de',
    pricing: 'Precios',
    support: 'Soporte',
    admin: 'Admin',
    downloadApp: 'Descargar App',
  },

  // Hero Section
  hero: {
    title: 'Una app de inspiración que *amarás*',
    subtitle: 'Inspiración diaria, imágenes generadas por IA y reflexiones personales para una vida más motivada',
    downloadIOS: 'Descargar para iOS',
    downloadIOSTestFlight: 'Descargar para iOS (TestFlight)',
    comingSoonAndroid: 'Próximamente para Android',
    freeTrialNote: 'No requiere tarjeta de crédito • 7 días de prueba gratis',
    note: 'No requiere tarjeta de crédito • 3 días de prueba gratis',
    mockupQuote: 'La mejor manera de predecir el futuro es crearlo.',
    mockupAuthor: '- Peter Drucker',
    playVideo: 'Reproducir video',
  },

  // Quote Example
  quote: {
    example: 'La mejor manera de predecir el futuro es crearlo.',
    author: 'Peter Drucker',
    category: 'Liderazgo y Mentalidad',
  },

  // Features Section
  features: {
    title: 'Todo lo que necesitas para la inspiración diaria',
    subtitle: 'Experimenta el viaje completo de la inspiración diaria',
    screenshots: {
      categories: {
        title: 'Personaliza tu viaje',
        description: 'Elige entre 5 categorías que resuenan con tus objetivos: Inspiración Diaria, Deportes, Liderazgo, Mindfulness y Relaciones.',
      },
      favorites: {
        title: 'Colecciona tus favoritos',
        description: 'Guarda las citas que más te inspiran y revísalas cuando necesites motivación.',
      },
      share: {
        title: 'Comparte tu inspiración',
        description: 'Difunde energía positiva compartiendo tarjetas de citas bellamente diseñadas con amigos y familiares.',
      },
    },
    feature1: {
      title: 'Inspiración Diaria',
      description: 'Una nueva cita motivadora cada día de 5 categorías: Inspiración, Deportes, Liderazgo, Mindfulness y Relaciones.',
    },
    feature2: {
      title: 'Imágenes Generadas por IA',
      description: 'Cada cita se presenta con una imagen de fondo única generada por IA que combina perfectamente con el estado de ánimo.',
    },
    feature3: {
      title: 'Reflexión Personal',
      description: 'Escribe tus pensamientos sobre cada cita y sigue tu desarrollo personal a lo largo del tiempo.',
    },
    feature4: {
      title: 'Recordatorios Inteligentes',
      description: 'Recibe tu inspiración diaria en el momento perfecto - personalizable y discreto.',
    },
    feature5: {
      title: 'Multiidioma',
      description: 'Disponible en alemán, inglés, español y francés - todo adaptado automáticamente a tu idioma.',
    },
    feature6: {
      title: 'Funciona sin conexión',
      description: 'Tu inspiración siempre está disponible, incluso sin conexión a internet.',
    },
    dailyInspiration: {
      title: 'Inspiración Diaria',
      description: 'Una nueva cita motivadora cada día de 5 categorías.',
    },
    aiImages: {
      title: 'Imágenes Generadas por IA',
      description: 'Cada cita se presenta con una imagen única generada por IA.',
    },
    personalReflection: {
      title: 'Reflexión Personal',
      description: 'Escribe tus pensamientos sobre cada cita.',
    },
    smartReminders: {
      title: 'Recordatorios Inteligentes',
      description: 'Recibe tu inspiración en el momento perfecto.',
    },
    multilingual: {
      title: 'Multiidioma',
      description: 'Disponible en alemán, inglés, español y francés.',
    },
    offline: {
      title: 'Funciona sin conexión',
      description: 'Tu inspiración siempre está disponible.',
    },
  },

  // Categories Section
  categories: {
    title: '5 categorías para cada área de la vida',
    daily: {
      name: 'Inspiración Diaria',
      description: 'Citas motivadoras para cada día',
    },
    sport: {
      name: 'Deporte y Disciplina',
      description: 'Motivación para entrenar y perseverar',
    },
    leadership: {
      name: 'Liderazgo y Mentalidad',
      description: 'Liderazgo y pensamiento empresarial',
    },
    mindfulness: {
      name: 'Mindfulness y Balance',
      description: 'Paz interior y equilibrio vital',
    },
    relationships: {
      name: 'Relaciones y Cercanía',
      description: 'Amor, amistad y conexiones interpersonales',
    },
    inspiration: {
      title: 'Inspiración Diaria',
      description: 'Citas motivadoras para tu día a día',
    },
    sports: {
      title: 'Deporte y Disciplina',
      description: 'Fortalece tu cuerpo y mente',
    },
  },

  // Pricing Section
  pricing: {
    title: 'Elige tu Plan',
    subtitle: 'Desbloquea todas las funciones premium',
    monthly: {
      title: 'Mensual',
      price: '€2,99',
      period: 'por mes',
      features: [
        'Inspiración diaria',
        'Imágenes generadas por IA',
        'Diario personal',
        'Recordatorios personalizables',
        'Todas las categorías',
        'Funciones de exportación',
        'Sin anuncios',
      ],
      cta: 'Elegir Mensual',
    },
    yearly: {
      title: 'Anual',
      price: '€14,99',
      period: 'por año',
      badge: 'Mejor Valor',
      features: [
        'Inspiración diaria',
        'Imágenes generadas por IA',
        'Diario personal',
        'Recordatorios personalizables',
        'Todas las categorías',
        'Funciones de exportación',
        'Sin anuncios',
      ],
      cta: 'Elegir Anual',
      savings: 'Ahorra 58%',
    },
  },

  // Footer
  footer: {
    copyright: 'Todos los derechos reservados.',
    madeWith: 'Hecho con ❤️ en Alemania',
    product: {
      title: 'Producto',
      features: 'Características',
      pricing: 'Precios',
      admin: 'Admin',
    },
    support: {
      title: 'Soporte',
      help: 'Ayuda',
      contact: 'Contacto',
      faq: 'FAQ',
    },
    legal: {
      title: 'Legal',
      privacy: 'Privacidad',
      terms: 'Términos de Servicio',
      imprint: 'Aviso Legal',
      eula: 'Acuerdo de Licencia de Usuario Final',
    },
  },
};